import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';
import { DETAIL_HEADER_HEIGHT } from '../../Navigation/Menu/Menu.styles';

let baseStyles = {
    devicePicker: {
        position: 'absolute',
        zIndex: 10,
        elevation: 10,
        left: 0,
        right: 0,
        top: Device.isWeb ? -DETAIL_HEADER_HEIGHT : 0,
        bottom: 0
    },
    actionPicker: {
        position: 'absolute',
        zIndex: 10,
        elevation: 10,
        right: 0,
        top: 0
    },
    searchInput: {
        padding: 8,
        margin: 0,
        width: '100%',
        fontFamily: Theme.regularFont,
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        lineHeight: 24,
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        alignSelf: 'auto'
    },
    headerTitle: {
        flex: 1,
        justifyContent: 'center'
    },
    dialogFooterStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        height: 140
    },
    buttonSeparatorStyle: {
        height: 1,
        width: '100%'
    },
    searchInputContainer: {
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        borderRadius: 4,
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'center',
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        lineHeight: 24
    },
    cancelIcon: {
        width: 20,
        height: 20,
        marginRight: 16,
        marginLeft: 10,
        marginTop: 10
    },
    searchMarginContainer: {
        margin: Theme.primaryMargin
    },
    currentDeviceLabel: {
        color: Theme.secondaryTextColor
    },
    confirmationModalContainer: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.9)'
    },
    container: {
        position: 'relative',
        flex: 1
    }
};

if (Device.isWeb) {
    baseStyles.searchMarginContainer = {
        ...baseStyles.searchMarginContainer,
        paddingTop: 40,
        marginHorizontal: '20%'
    };
    baseStyles.searchInputContainer = {
        paddingTop: 40
    };
}

if (Device.isTablet) {
    baseStyles = {
        ...baseStyles,
        favoriteSettingsTabsContainer: {
            backgroundColor: Theme.primaryBackgroundColor,
            width: '100%',
            height: 50,
            position: 'absolute',
            top: 0
        },
        searchMarginContainer: {
            ...baseStyles.searchMarginContainer,
            marginHorizontal: '20%'
        }
    };
}

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        searchInput: {
            ...baseStyles.searchInput,
            padding: 15,
            fontSize: 21
        },
        cancelIcon: {
            ...baseStyles.cancelIcon,
            marginTop: 16
        }
    };
}

export default StyleSheet.create(baseStyles);
